const QuestionTypes = {
    'implementation_status_new': {
        name: "Implementation Status",
        title: "Implementation Status",
        buttons: {
            "7": {label: "None", value: "7", color: "is-danger", order: 1},
            "8": {label: "Partial", value: "8", color: "is-warning", order: 2},
            "9": {label: "Full", value: "9", color: "is-success", order: 3},
            "-1": {label: "N/A", value: "-1", color: 'is-dark', order: 4}
        }
    },
    'yes_no_new': {
        title: "Answer",
        buttons: {
            "7": {label: "No", value: "7", color: "is-danger", order: 1},
            "8": {label: "Partial", value: "8", color: "is-warning", order: 2},
            "9": {label: "Yes", value: "9", color: "is-success", order: 3},
            "-1": {label: "N/A", value: "-1", color: 'is-dark', order: 4}
        }
    },
    'implementation_status': {
        name: "Implementation Status",
        title: "Implementation Status",
        buttons: {
            "1": {label: "None", value: "1", color: "is-danger", order: 1},
            "2": {label: "Partial", value: "2", color: "is-warning", order: 2},
            "3": {label: "Full", value: "3", color: "is-success", order: 3},
            "-1": {label: "N/A", value: "-1", color: 'is-dark', order: 4}
        }
    },
    'yes_no': {
        title: "Answer",
        buttons: {
            "2": {label: "Yes", value: "2", color: "is-success", order: 1},
            "1": {label: "No", value: "1", color: "is-danger", order: 2},
            "3": {label: "Partial", value: "3", color: "is-warning", order: 3},
            "-1": {label: "N/A", value: "-1", color: 'is-dark', order: 4}
        }
    },
    'free_text': {
        title: "Answer"
    }
}

export default QuestionTypes;